import { render, staticRenderFns } from "./NewPerseuCard.vue?vue&type=template&id=1530a978&scoped=true&"
import script from "./NewPerseuCard.vue?vue&type=script&lang=js&"
export * from "./NewPerseuCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1530a978",
  null
  
)

export default component.exports